import { render } from "./EnbLink.vue?vue&type=template&id=22d3c65a&scoped=true"
import script from "./EnbLink.vue?vue&type=script&lang=js"
export * from "./EnbLink.vue?vue&type=script&lang=js"

import "./EnbLink.vue?vue&type=style&index=0&id=22d3c65a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22d3c65a"]])

export default __exports__